var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { UnifiedRestServiceBase } from "./ExpAPIVUnified.resource.js";
import { noCache } from "../../services/middlewares/NoCacheMiddleware.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { buildOdataQuery } from "@ane/core/lib/utils/ODataUtils";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let VariantUnifiedResource = class extends UnifiedRestServiceBase {
  constructor() {
    super("variants");
  }
  updateCompositionAsync(workspaceId, variantId, compositionGraph) {
    return __async(this, null, function* () {
      return this._put(
        compositionGraph,
        buildOdataQuery(void 0, {
          baseUrl: `${this.getResourceUrl(workspaceId, variantId)}/composition`,
          additionalQueryParams: this.getDefaultQueryParams()
        })
      );
    });
  }
  getCompositionAsync(workspaceId, variantId) {
    return __async(this, null, function* () {
      return this._get(
        buildOdataQuery(void 0, {
          baseUrl: `${this.getResourceUrl(workspaceId, variantId)}/composition`,
          additionalQueryParams: this.getDefaultQueryParams()
        })
      );
    });
  }
};
VariantUnifiedResource = __decorateClass([
  noCache(),
  WPSProxyConverter()
], VariantUnifiedResource);
const VariantUnifiedResourceInstance = new VariantUnifiedResource();
export {
  VariantUnifiedResource,
  VariantUnifiedResourceInstance as default
};
//# sourceMappingURL=Variant.unified.resource.js.map
